import {
  SHOW_MODAL
} from '../actions'

function modalReducer(state = false, action) {
  switch (action.type) {
  case SHOW_MODAL:
    return action.show
  default:
    return state
  }
}

export default modalReducer


// WEBPACK FOOTER //
// ./src/reducers/modal.js